import React from 'react'
import { ListProps } from 'react-admin'
import { makeStyles } from '@material-ui/core'
import {
  NodeActions,
  TreeWithDetails,
} from '../../../lib/@react-admin/ra-tree/esm/src'
import { DeviceManagementContainerShow } from '../device-management/DeviceManagementContainerShow'

const useStyles = makeStyles({
  tree: {
    '& .rc-tree-title > div > button': {
      visibility: 'hidden',
    },
  },
})

export const DevicesViewList = ({ ...props }: ListProps) => {
  const classes = useStyles()

  return (
    <TreeWithDetails
      className={classes.tree}
      titleField="name"
      linkTo="show"
      show={DeviceManagementContainerShow}
      {...props}
      // allowMultipleRoots={hasAuthority(
      //   Authority.CREATE_DEVICE_MANAGEMENT_CONTAINERS,
      // )}
      // eslint-disable-next-line react/no-children-prop
      nodeActions={<NodeActions children={[]} />}
    />
  )
}
